import React from "react";
import { Link, Navigate } from "react-router-dom";
import { Avatar, Breadcrumb, Button, Col, Divider, FloatButton, Form, Input, Row, Typography, Upload, message } from "antd";


import { POST_API, POST_CATCH, UPLOAD_API, getToken, getUPLOADAPI } from "../services/hello-api";

import Pageload from "../components/Pageload";
import { IoAddOutline, IoArrowBack, IoCameraOutline } from "react-icons/io5";
import ImgCrop from "antd-img-crop";

class TimelineAdd extends React.Component {

    state = { _loading: false, _navigate: false, _user: null, _menu: false }

    componentDidMount = () => {}

    onSend = (values) => {
        this.setState({_loading: true})
        POST_API('/timeline/save.php', { token: getToken(), master: JSON.stringify(values) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({ _navigate: true })
                message.success({ content: res.msg, key: 'screen' })
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => {
            message.error({ content: 'Não foi possível estabelecer uma conexão com o sistema', key: 'screen' })
        }).finally(() => this.setState({_loading: false}))
    }

    render = ( ) => {

        const routes = [
            {title: <Link to={'..'}><Typography className="page-bread">Timeline</Typography></Link>},
            {title: <Typography className="page-bread active">Adicionar</Typography>}
        ]

        if (this.state._navigate) return <Navigate to="/dashboard" />

        return (
            <Row>
                <Col xs={24} md={0}>
                    <Breadcrumb items={routes} className="bread-page" />
                    <Link to=".."><FloatButton className="float-button back" icon={<IoArrowBack color="#FFF" size={25} />}/></Link>
                </Col>
                <Col xs={0} md={24} className="page-header">
                    <Row className="table__row_table" gutter={[8,8]}>
                        <Col span={24}>
                            <Breadcrumb items={routes} />
                        </Col>
                    </Row>
                </Col>
                <Col span={24} className="page-content">
                    <Row className="table__row_table" gutter={[8,8]} align={'bottom'}>
                        <Col span={24}>
                            <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                <Form.Item label="Foto" name="PHOTO" class="profile-form-item" rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                    <Upload action={UPLOAD_API} accept="image/*" maxCount={1}>
                                        <Button type="primary">Adicionar Foto</Button>
                                    </Upload>
                                </Form.Item>
                                <Form.Item label="Deixe uma mensagem" name="TEXTO" class="profile-form-item">
                                    <Input.TextArea></Input.TextArea>
                                </Form.Item>
                                <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" style={{float: 'right'}}>Publicar</Button>
                            </Form>

                        </Col>
                    </Row>
                </Col>
            </Row>
        )
    }

}

export default TimelineAdd;